<template>
<div class="field radio-field">
      <label class="label">
        {{ question.title }}
        <b-tooltip :label="question.desc"
                   v-if="question.desc !== ''"
                   type="is-light"

                   position="is-right" size="is-large" multilined>
          <div class="tooltip-icon">!</div>
        </b-tooltip>
      </label>
      <div class="sep-16"></div>
      <div class="control radio-group" vrules="required">
        <label class="radio" v-for="answer in question.answer_set"
               v-if="question.answer_set.length > 0">
          <input :value="answer.id"
                 type="radio"
                 :name="'answer_'+question.id"
                 @click="onAnswer(answer, question)"
                 :checked="value && value.id === answer.id" />
          {{ answer.title }}
        </label>
        <div class="help is-danger vrule" rule="required">
          This field is required.
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "RadioBox",
  props: ['value', 'question'],
  data(){
    return {
      selectedAnswer: '',
    }
  },
  methods: {
    onAnswer(answer, question){
      this.$emit('input', answer)
      this.$emit('onAnswer', answer, question)
    }
  },
  beforeDestroy() {
    // console.log('beforeDestroy')
  }
}
</script>

<style scoped>

</style>
